<template>
  <email-form-modal
    :modal-id="modalId"
    :title="terminology.verificationEmailTitle"
    :initial-emails="email ? [email] : null"
    :initial-form="initialForm"
    :request="submitRequest"
    @success="(complianceDocument) => $emit('input', complianceDocument)"
  >
    <template #fields="{ form }">
      <b-row>
        <b-col cols="12">
          <b-form-group label-for="compliance-document-verification-email-cc_manager">
            <b-form-checkbox
              id="compliance-document-verification-email-cc_manager"
              v-model="form.cc_manager"
            >
              CC Manager
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </template>
  </email-form-modal>
</template>

<script>
import complianceDocumentTerminology from '@/utils/complianceDocumentTerminology';
import EmailFormModal from '@/components/shared/EmailFormModal.vue';

export default {
  name: 'ComplianceDocumentVerificationsEmailModal',
  components: {
    EmailFormModal,
  },
  props: {
    value: Object,
    email: String,
    cc_manager: Boolean,
    documentType: String,
  },
  data() {
    return {
      modalId: 'compliance-document-verification-email-modal',
    };
  },
  computed: {
    terminology() {
      return complianceDocumentTerminology(this.documentType);
    },
    initialForm() {
      return {
        cc_manager: this.cc_manager,
      };
    },
  },
  methods: {
    submitRequest(payload) {
      return this.$complianceDocumentVerificationsAPI.email(this.value.id, payload);
    },
  },
};
</script>
